import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from '../services/account.service';


interface DialogData {
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-resetpassmodal',
  templateUrl: './resetpassmodal.component.html',
  styleUrls: ['./resetpassmodal.component.scss']
})
export class ResetpassmodalComponent implements OnInit {

  hide = true;

  updateForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<ResetpassmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private accountService: AccountService) { }

  cancel(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.updateForm = this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required]
    })
  }

  submit() {
    let passwordData = {
      'password': this.updateForm.get('password').value,
      'confirm_password': this.updateForm.get('confirmPassword').value
    }
    this.accountService.updatePassword(passwordData).then((res:any) => {
      if(res.success){
        alert('Password Changed Successfuly')
        this.cancel();
      }
     else {
       alert(res.error)
     }
    })
      .catch((error) => {
        console.log(error)
      })
  }

}
